import HomeScreen from "./index";

const routes = [
  {
    path: "/",
    component: HomeScreen,
  },
];

export default routes;
